import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const Login = (props) => {
  return (
    <div className="fixed h-full w-full overflow-hidden">
      <div className="bg-gray-300 opacity-50 h-full w-full absolute"></div>
      <div className="relative bg-white w-full max-w-md ml-auto mr-15% opacity-100 pt-auto rounded-md">
        <div className="flex flex-col h-full mt-16">
          <div className="flex justify-between items-center px-8 border-b border-gray-100 pb-4">
            <h5 className="mt-4 text-2xl text-basic-orange">
              Silahkan Masuk / Daftar
            </h5>
            <button onClick={props.handdleClick} className="h-3 w-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18.461 19.883"
              >
                <g
                  id="Group_3838"
                  data-name="Group 3838"
                  transform="translate(1.413 1.413)"
                >
                  <line
                    id="Line_434"
                    data-name="Line 434"
                    x1="15.635"
                    y2="17.057"
                    fill="none"
                    stroke="#596375"
                    strokeLinecap="round"
                    strokeWidth="2"
                  />
                  <line
                    id="Line_435"
                    data-name="Line 435"
                    x2="15.635"
                    y2="17.057"
                    fill="none"
                    stroke="#596375"
                    strokeLinecap="round"
                    strokeWidth="2"
                  />
                </g>
              </svg>
            </button>
          </div>
          <div className="bg-white flex flex-col px-8 py-3 flex-1">
            <label className="block bg-white">
              <input
                type="text"
                className="mt-4 block w-full px-8 py-3 mb-8 border-b-2 border-l-0 border-r-0 border-t-0 focus:outline-none outline-none focus:shadow-none"
                placeholder="Masukkan nomor handphone"
              ></input>
            </label>
            <label className="block bg-white">
              <input
                type="password"
                className="mt-4 block w-full px-8 py-3 mb-8 border-b-2 border-l-0 border-r-0 border-t-0 focus:outline-none outline-none"
                placeholder="Masukkan password"
              ></input>
            </label>
            <div className="flex flex-row-reverse">
              <label>
                <button className="ml-3xl">
                  <span className="underline text-gray-500">Lupa password</span>
                </button>
              </label>
            </div>
          </div>
          {/* Footer Login */}
          <div className="flex flex-col justify-between items-center py-4 px-8 ">
            <Link
              to="/checkout"
              className="bg-basic-orange w-full text-white rounded-l-full rounded-r-full px-8 py-3 capitalize text-center"
            >
              Masuk
            </Link>
            <div class="flex flex-row mt-6">
              <div className="px-2 py-2 m-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="36"
                  viewBox="0 0 56 56"
                >
                  <circle
                    id="google_login_area"
                    data-name="google login area"
                    cx="28"
                    cy="28"
                    r="28"
                    fill="#f5f6f9"
                  />
                  <path
                    id="Icon_ionic-md-mail"
                    data-name="Icon ionic-md-mail"
                    d="M25.747,5.625H4.723A2.481,2.481,0,0,0,2.25,8.1V23.557A2.481,2.481,0,0,0,4.723,26.03H25.747a2.481,2.481,0,0,0,2.473-2.473V8.1A2.481,2.481,0,0,0,25.747,5.625Zm-.309,5.256-10.2,6.8-10.2-6.8V8.408l10.2,6.8,10.2-6.8Z"
                    transform="translate(13.004 12.06)"
                    fill="#596375"
                    opacity="0.5"
                  />
                </svg>
              </div>
              <div className="px-2 py-2 m-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="36"
                  viewBox="0 0 56 56"
                >
                  <circle
                    id="fb_login_area"
                    data-name="fb login area"
                    cx="28"
                    cy="28"
                    r="28"
                    fill="#f5f6f9"
                  />
                  <g id="facebook-2" transform="translate(22.571 16.304)">
                    <path
                      id="Path_fb"
                      data-name="Path fb"
                      d="M7.119,21.119V11.485h3.234l.484-3.754H7.119v-2.4c0-1.087.3-1.828,1.861-1.828h1.988V.148A26.644,26.644,0,0,0,8.071,0C5.2,0,3.242,1.749,3.242,4.963V7.731H0v3.754H3.242v9.633Z"
                      transform="translate(0 0)"
                      fill="#3c5a9a"
                    />
                  </g>
                </svg>
              </div>
              <div className="px-2 py-2 m-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="36"
                  viewBox="0 0 56 56"
                >
                  <circle
                    id="twitter_login_area"
                    data-name="twitter login area"
                    cx="28"
                    cy="28"
                    r="28"
                    fill="#f5f6f9"
                  />
                  <g id="twitter-3" transform="translate(16.821 17.796)">
                    <path
                      id="Path_twitter"
                      data-name="Path twitter"
                      d="M22.622,2.175a9.266,9.266,0,0,1-2.665.731A4.654,4.654,0,0,0,22,.339,9.271,9.271,0,0,1,19.05,1.465a4.643,4.643,0,0,0-8.028,3.176,4.694,4.694,0,0,0,.12,1.058A13.177,13.177,0,0,1,1.576.85a4.645,4.645,0,0,0,1.436,6.2,4.62,4.62,0,0,1-2.1-.58v.059a4.643,4.643,0,0,0,3.723,4.55,4.617,4.617,0,0,1-1.223.163,4.71,4.71,0,0,1-.874-.082,4.647,4.647,0,0,0,4.335,3.223,9.31,9.31,0,0,1-5.763,1.987A9.257,9.257,0,0,1,0,16.3a13.133,13.133,0,0,0,7.114,2.086,13.114,13.114,0,0,0,13.2-13.2q0-.3-.014-.6a9.456,9.456,0,0,0,2.319-2.406Z"
                      transform="translate(0 0)"
                      fill="#2daae1"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div className="px-2 py-2 mx-4 ">
              <p className="text-md font-gray-100">
                Tidak memiliki akun ?{' '}
                <button className="text-basic-orange bold">Daftar</button>
              </p>
            </div>
          </div>
          {/* End Footer Login */}
        </div>
      </div>
    </div>
  );
};

export default Login;
